export default async function() {
    const { getUserCertificates } = window.cryptoPro;

    // getUserCertificates() already filters by validity and private-key presence at the
    // store level, so a client-side isValid() check is redundant even when awaited — and
    // isValid() returns a Promise, so the previous `.filter(cert => cert.isValid())` was
    // silently a no-op (always truthy). Deleted rather than fixed: awaiting it would just
    // re-confirm what the store already guarantees, for the cost of an extra async call.
    return (await getUserCertificates()).map(cert => {
        return {
            ...cert,
            subject: parseOpenSSL(cert.subjectName),
            issuer: parseOpenSSL(cert.issuerName)
        };
    });
}

function parseOpenSSL(subjectString) {
    subjectString = subjectString.replace('ИНН ЮЛ', 'ИННЮЛ');
    // A quoted value runs to its closing quote; `""` and `\x` inside it are escapes, not the end.
    const regex = /([A-ZА-Я]+)=("(?:[^"\\]|""|\\.)*"|[^,]+)/g;
    let match;
    const result = {};

    while ((match = regex.exec(subjectString)) !== null) {
        const key = match[1];
        let value = match[2];

        // Remove surrounding quotes and unescape inner quotes if they exist
        value = value.replace(/^"|"$/g, '').replaceAll('""', '"');

        result[key] = value;
    }

    return result;
}
